export const PlayIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.6" cx="25" cy="25" r="25" transform="matrix(-1 0 0 1 50 0)" fill="#1F0C19" />
    <path
      d="M18 17.458V32.542C18 33.6922 19.2667 34.3911 20.2422 33.765L32.0939 26.223C32.9966 25.6552 32.9966 24.3448 32.0939 23.7624L20.2422 16.235C19.2667 15.6089 18 16.3078 18 17.458Z"
      fill="#E9E7E8"
    />
  </svg>
);
